import styled from 'styled-components';

export const ViewContainer = styled.div`
  margin-top: 20px;
  width: 500px;
`;

export const EditContestantsArea = styled.div`
  border-radius: 10px;
  width: 100%;
  padding: 16px;
  background-color: #fff;
  display: flex;
  align-items: center;
  height: 60px;
  cursor: pointer;
  gap: 20px;
`;

export const EditContestantsText = styled.div`
  color: #5f27cd;
  font-family: Space Grotesk;
  font-weight: 500;
`;

export const CustomSeedValue = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CustomSeedValueImage = styled.img`
  border-radius: 100%;
  width: 36px;
  height: 36px;
  object-fit: cover;
`;

export const CustomSeedValueText = styled.div`
  font-weight: 500;
`;
